import { render, staticRenderFns } from "./ModalSimple.vue?vue&type=template&id=04e7d23c&scoped=true&"
import script from "./ModalSimple.vue?vue&type=script&lang=js&"
export * from "./ModalSimple.vue?vue&type=script&lang=js&"
import style0 from "./ModalSimple.vue?vue&type=style&index=0&id=04e7d23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7d23c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VIcon,VTextField})
